import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Stack,
  TextField
} from "@mui/material";
import { get } from "lodash";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import ProtectedPermissionPage from "../../components/ProtectedPermissionPage";
import useNotification from "../../hooks/useNotification";
import product from "../../services/product";
import queryDefault from "../../utils/queryDefault";
import { Helmet } from "react-helmet-async";
import PageName from "../components/PageName";

export default function SubProductAdminEdit() {
  const { id } = useParams();
  const notification = useNotification();
  const navigate = useNavigate();
  const schema = yup.object().shape({
    name: yup.string().required("Name is a required field"),
    link: yup.string().required("Link URL Color is a required field"),
  });
  const currentSubProduct = useQuery("view-link", () => product.detailSubProduct(Number(id)));
  const form = useForm({
    defaultValues: {
      id: id,
      productid: 0,
      name: "",
      name_id: "",
      link: ""
    },
    resolver: yupResolver(schema),
  });

  const updateSubProduct = useMutation("update-subproduct", product.editSubProduct, {
    onSuccess: (response) => {
      navigate("/admin/product/");

      notification.onOpen({
        message: response.message === "" ? "Sub Product was successfully updated!" : response.message,
        type: "success",
        position: "top",
      });
    },
    onError: (error: any) => {
      notification.onOpen({
        message: error?.response?.data?.message === undefined ? "Something went wrong" : error?.response?.data?.message,
        type: "error",
        position: "top",
      });
    },
    ...queryDefault,
  });

  const onSubmit = (values: any) => {
    updateSubProduct.mutate({
      data: {
        ...values,
        id: id
      }
    })
  };

  useEffect(() => {
    if (id) {
      form.setValue("id", id);
      form.setValue("productid", get(currentSubProduct, "data.data.productid"));
      form.setValue("name", get(currentSubProduct, "data.data.name"));
      form.setValue("name_id", get(currentSubProduct, "data.data.name_id"));
      form.setValue("link", get(currentSubProduct, "data.data.link"));
    }
  }, [currentSubProduct, form, id]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FDF3DF",
        height: "100vh",
        paddingRight: "5vw"
      }}
    >
      <Helmet>
        <title>Edit Sub Product</title>
      </Helmet>

      <PageName page="PRODUCT" width="240" />

      <ProtectedPermissionPage acceptPermissions={[7]}>
        {!currentSubProduct.isLoading ? (
          <Box sx={{ mt: 15, backgroundColor: "#fbf3dc" }}>
            <Grid container>
              <Grid item lg={12} xs={12}>
                <FormControl fullWidth margin="normal">
                  <FormLabel required>Sub Product Name</FormLabel>
                  <Controller
                    name="name"
                    control={form.control}
                    render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                        {...field}
                        inputRef={ref}
                        error={Boolean(fieldState.error?.message)}
                        helperText={fieldState.error?.message}
                        size="small"
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <FormLabel required>Nama Sub Produk</FormLabel>
                  <Controller
                    name="name_id"
                    control={form.control}
                    render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                        {...field}
                        inputRef={ref}
                        error={Boolean(fieldState.error?.message)}
                        helperText={fieldState.error?.message}
                        size="small"
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <FormLabel required>Link URL</FormLabel>
                  <Controller
                    name="link"
                    control={form.control}
                    render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                        {...field}
                        inputRef={ref}
                        error={Boolean(fieldState.error?.message)}
                        helperText={fieldState.error?.message}
                        size="small"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>) : <></>}
        <Box sx={{ mt: 3, backgroundColor: "#fbf3dc" }}>
          <Stack direction="row" spacing={1}>
            <LoadingButton
              variant="contained"
              onClick={form.handleSubmit(onSubmit)}
              loading={updateSubProduct.isLoading}
            >
              SAVE
            </LoadingButton>

            <Button variant="outlined" onClick={() => navigate(-1)}>
              CANCEL
            </Button>
          </Stack>
        </Box>
      </ProtectedPermissionPage>
    </Box>
  );
}
